import React from 'react';
import classNames from 'classnames';

export interface SidebarProps {
  /**
   * @default false
   */
  collapse: boolean;

  /**
   * @default true
   */
  fixed: boolean;
  children: JSX.Element | JSX.Element[] | string;
}

const SidebarPro = ({
  collapse = false,
  fixed = true,
  children = <></>,
}: SidebarProps) => {
  return (
    <aside
      className={classNames('sidebar-pro p-8 border-end', {
        'sidebar-pro-fixed': fixed,
        'sidebar-pro-collapsed': collapse,
      })}
    >
      {children}
    </aside>
  );
};

export default SidebarPro;
